import { Button, Card, Col, Popover, Row, Select } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import { formatPhoneNumber } from 'react-phone-number-input'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import { JOBS } from '../../Common/Common'

export default function BoxIntervenersTab ({ form, interveners }) {
  const [displayedInterveners, setDisplayedInterveners] = useState(form.getFieldValue('interveners') || [])
  const [intervener, setIntervener] = useState()
  const [job, setJob] = useState()

  const addIntervener = () => {
    const addedIntervener = interveners.find(i => i.id === intervener)
    const iArray = [...displayedInterveners, addedIntervener]
    setDisplayedInterveners(iArray)
    form.setFieldValue('interveners', iArray)
    setIntervener(null)
  }

  const removeIntervener = (i) => {
    const iArray = [...displayedInterveners.filter(intervener => intervener.id !== i.id)]
    setDisplayedInterveners(iArray)
    form.setFieldValue('interveners', iArray)
  }

  const displayInterveners = () => {
    return (
      displayedInterveners.map(i => (
        <Popover key={i.id} content={i.description} placement='topLeft'>
          <Row style={{ flexFlow: 'row', marginBottom: '1em' }}>
            <Col span={3} style={{ marginRight: 'auto' }}><Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>
              {t(`Admin.IntervenersList.table.job.${i.job}`)}
            </Card></Col>
            <Col span={6} style={{ marginRight: 'auto' }}><Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>{i.name}</Card></Col>
            {displayCommunicationMeans(i.phones, i.emails)}
            <Button onClick={() => removeIntervener(i)} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<MinusOutlined />} />
          </Row>
        </Popover>
      ))
    )
  }

  const displayCommunicationMeans = (phones, emails) => {
    return (
      <>
        <Col span={4} style={{ marginRight: 'auto' }}>
          {phones.map(phone => (
            displayCommunication(phone)
          ))}
        </Col>
        <Col span={6} style={{ marginRight: 'auto' }}>
          {emails.map(email => (
            displayCommunication(email)
          ))}
        </Col>
      </>
    )
  }

  const displayCommunication = (communication) => {
    const value = communication.field_type === 'phone' ? formatPhoneNumber(`+${communication.value}`) : communication.value
    return (
      <>
        {communication.description &&
          <Popover content={communication.description}>
            <Card styles={ { body: { padding: '3px', textAlign: 'center' } }}>{value}</Card>
          </Popover>
        }
        {!communication.description &&
          <Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>{value}</Card>
        }
      </>
    )
  }

  const filteredInterveners = (interveners, job, displayedInterveners) => {
    if (job) {
      return interveners?.filter(i => i.job === job && !displayedInterveners.map(e => e.id).includes(i.id))
    } else {
      return interveners?.filter(i => !displayedInterveners.map(e => e.id).includes(i.id))
    }
  }

  return (
    <div>
      <Row style={{ marginBottom: '2em' }}>
        <Select
          showSearch={{
            optionFilterProp: 'children',
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
          allowClear
          placeholder="Filtrer par fonction"
          options={JOBS.map((o) => ({ label: t(`Admin.IntervenersList.table.job.${o}`), value: o }))}
          onSelect={(value) => setJob(value)}
          onClear={() => setJob(null)}
          value={job}
          style={{ width: '18em' }}
        />
        <Select
          showSearch={{
            optionFilterProp: 'children',
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
          placeholder="Rechercher un intervenant"
          options={filteredInterveners(interveners, job, displayedInterveners).map((o) => ({ label: o.name, value: o.id }))}
          onSelect={(value) => setIntervener(value)}
          value={intervener}
          style={{ width: '23em' }}
        />
        <Button disabled={!intervener} onClick={addIntervener} type="primary" style={{ marginLeft: '2em' }} shape="circle" icon={<PlusOutlined />} />
      </Row>
      {displayInterveners()}
    </div>
  )
}
